import { useEffect, useState } from 'react'
import { useSpring, animated } from '@react-spring/web'
import microApp from '@micro-zoe/micro-app'
import { IAppItem, INavItem, genNavTree, getFirstNavPath, useAppNavigate } from '@mkmp/core'
import { Icon } from 'mk-pc'
import { useAppStore } from '@/stores'
import { AsideMenu } from '@/components'
import './index.scss'

interface Props {
  isOpen?: boolean
  active?: string
  expand?: string
  onSelect?: (nav: INavItem) => void
}

interface IActiveValue {
  active: string
  expand: string
}

/**
 * 页面导航栏
 * @param param0
 * @returns
 */
export const LayoutAside = ({ onSelect }: Props) => {
  const navigate = useAppNavigate()
  const [navTree, setNavTree] = useState([] as Array<INavItem>)
  const { activePaths, layout } = useAppStore()
  const [currentActive, setCurrentActive] = useState({ active: '', expand: '' } as IActiveValue)

  // 返回全局数据
  const { org = {} } = (microApp.getGlobalData() || {}) as any
  const { navs = [], apps = [] } = org

  const [widthStyles, widthApi] = useSpring(() => {
    return {
      from: { width: 0 },
      config: { duration: 200 }
    }
  })

  const [displayStyles, displayApi] = useSpring(() => {
    return {
      from: { opacity: 0 },
      config: { duration: 500 }
    }
  })

  useEffect(() => {
    widthApi.start({ to: { width: layout.showNav ? 80 : 0 } })
    displayApi.start({ to: { opacity: layout.showNav ? 1 : 0 } })
  }, [layout.showNav])

  useEffect(() => {
    setNavTree(genNavTree(navs, '', 1))
  }, [navs])

  useEffect(() => {
    if (!activePaths) {
      setCurrentActive({ active: '', expand: '' })
      return
    }
    const [expandId, activeId] = activePaths.split(',')
    const value = {
      active: '',
      expand: expandId
    }

    const activeNav = navs.find((n: INavItem) => n.id === activeId)
    if (!activeNav || activeNav.type === 0) {
      value.active = expandId
    } else {
      value.active = activeNav.id
    }

    setCurrentActive(value)
  }, [activePaths])

  /**
   * 选择菜单后跳转
   * @param nav
   */
  const handleSelect = (nav: INavItem) => {
    if (!nav) return

    const app = apps.find((a: IAppItem) => a.id === nav.appId)
    if (!app) return

    // 存在地址，则直接进行跳转
    if (nav.path) {
      return navigate(nav.path, {
        appName: app ? app.code : '',
        appBaseRoute: app ? app.baseRoute : '',
        mainApp: app ? !!app.mainApp : false
      })
    }

    const menu = getFirstNavPath(navs || [], nav.id)
    if (!menu) return

    const menuApp = apps.find((a: IAppItem) => a.id === menu.appId)
    if (!menuApp) return

    navigate(menu.path, {
      appName: menuApp ? menuApp.code : '',
      appBaseRoute: menuApp ? menuApp.baseRoute : '',
      mainApp: menuApp ? !!menuApp.mainApp : false
    })
  }

  return (
    <animated.aside className="layout-aside" style={widthStyles}>
      {layout.showNav && (
        <animated.div style={displayStyles}>
          <header className="layout-aside__header">
            <Icon name="icon-zhankaicaidan" size="32" />
          </header>
          <div className="layout-aside__navs">
            <AsideMenu activeKey={currentActive.active} expandKey={currentActive.expand} items={navTree} onSelect={handleSelect} />
          </div>
        </animated.div>
      )}
    </animated.aside>
  )
}
